import $ from 'jquery';
import 'select2';
import 'select2/dist/css/select2.css'

export default function discountEvents() {
  // Handle discount has uses limit change
  const discountUsesLimit = document.getElementById('discount_uses_limit');
  document.getElementById('discount_has_uses_limit').addEventListener('change', (e) => {
    discountUsesLimit.disabled = e.target.value !== 'true';
  });

  // Initialize select2 equivalent 
  $('#discount_workshop_variant_ids').select2()
};